// Section 2b: Road Widening (New Proposal)
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Home } from "lucide-react";

export const RoadWideningSection = ({
  formData,
  setFormData,
  handleChange
}) => {
  return (
    <Card className="rounded-sm shadow-sm border-l-4 border-l-orange-400" data-testid="quick-road-widening">
      <CardHeader className="pb-3 bg-orange-100 rounded-t-xl border-b border-orange-200">
        <CardTitle className="font-heading tracking-tight text-lg flex items-center gap-2 text-orange-900">
          <Home className="h-5 w-5 text-muted-foreground" />
          {formData.projectMode === "greenfield" ? "2. Road Widening" : "Road Widening (New Proposal)"}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <Label className="font-medium">New Road Widening (Current Proposal)?</Label>
          <p className="text-xs text-muted-foreground -mt-1">
            Affects Net Plot Area for FSI. Reduces TDR purchase at 1:2 ratio.
          </p>
          <RadioGroup 
            value={formData.hasNewRoadWidening || "no"} 
            onValueChange={(value) => {
              setFormData({
                ...formData, 
                hasNewRoadWidening: value,
                newRoadWideningArea: value === "no" ? "0" : formData.newRoadWideningArea
              });
            }}
            className="flex gap-4"
            data-testid="quick-new-road-widening-radio"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="yes" id="q-new-road-widening-yes" data-testid="quick-new-road-widening-yes" />
              <Label htmlFor="q-new-road-widening-yes" className="font-normal cursor-pointer">Yes</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="no" id="q-new-road-widening-no" data-testid="quick-new-road-widening-no" />
              <Label htmlFor="q-new-road-widening-no" className="font-normal cursor-pointer">No</Label>
            </div>
          </RadioGroup>
          
          {formData.hasNewRoadWidening === "yes" && (
            <div className="space-y-2 animate-in fade-in slide-in-from-top-2 duration-300 max-w-xs">
              <Label htmlFor="q-newRoadWideningArea">New Road Widening Area (sq mtr)</Label>
              <Input
                id="q-newRoadWideningArea"
                name="newRoadWideningArea"
                type="number"
                value={formData.newRoadWideningArea}
                onChange={handleChange}
                placeholder="0"
                className="rounded-sm"
                data-testid="quick-new-road-widening"
              />
              <p className="text-xs text-muted-foreground">Net Plot reduced. TDR reduction = Area × 2</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
